import { User } from 'src/redux/types/auth'
const useUserData = () => {
  const data: User = JSON.parse(localStorage.getItem('USER_DATA')!)
  return data
}
export default useUserData
